<template>
  <div>
    <navigationBar :fill="true" />
    <div class="width-1200">
        <breadcrumb />
    </div>
    <div class="width-1200" style="margin-top: 50px;">
      <navStepList3 :current="step" />
      <template v-if="step === 1">
        <div class="b-section main">
          <div>
            <div>
              <div class="for-label" style="margin-bottom: 15px;">手机号码/邮箱：</div>
              <Input class="bg-color-242631 height-44 login-input" style="margin-bottom: 20px;" v-model.trim="form.name" clearable placeholder="请输入手机号码/邮箱" />
              <div class="for-label" style="margin-bottom: 15px;">验证码：</div>
              <div class="width-500" style="display: flex;">
                <Input
                  class="bg-color-242631 height-44  login-input"
                  type="text"
                  placeholder="请输入验证码"
                  clearable
                  v-model="form.code"
                  style="width: 400px"
                >
                </Input>
                <div style="margin-left: 20px;">
                  <identify
                    :identify-code="identifyCode"
                    :content-height="44"
                    @reloadEvent="reloadCodeEvent"
                  />
                </div>
                
              </div>
            </div>
            <Button class="next-btn" type="info" :loading="loading1" @click="handleSubmit(1)" ghost>下一步</Button>
          </div>
        </div>
      </template>
      <template v-if="step === 2">
        <div class="b-section main">
          <div>
            <div class="t-tips">为了你的帐号安全，请完成身份验证</div>
            <div>
              <div class="for-label" style="margin-bottom: 15px;">手机号码/邮箱：</div>
              <Input class="bg-color-242631 height-44 login-input" style="margin-bottom: 20px;" disabled :value="getLookValue()" clearable />
              <div class="for-label" style="margin-bottom: 15px;">验证码：</div>
              <div class="width-500" style="display: flex;">
                <Input
                  class="bg-color-242631 height-44  login-input"
                  type="text"
                  placeholder="请输入验证码"
                  clearable
                  v-model="form.code"
                  style="width: 400px"
                  @on-keyup="form.code = form.code.replace(/[^\d]/g, '')"
                >
                </Input>
                <div style="margin-left: 20px;">
                  <smsBtn
                    ref="smsBtn"
                    height="44px"
                    @tap="getCodeEvent"
                    style="width: 120px"
                  ></smsBtn>
                </div>
                
              </div>
            </div>
            <Button class="next-btn" type="info" :loading="loading2" @click="handleSubmit(2)" ghost>下一步</Button>
          </div>
        </div>
      </template>
      <template v-if="step === 3">
        <div class="b-section main">
          <div>
            <div class="t-tips">为了你的帐号安全，请完成身份验证</div>
            <div>
              <div class="for-label" style="margin-bottom: 15px;">手机号码/邮箱：</div>
              <Input class="bg-color-242631 height-44 login-input" style="margin-bottom: 20px;" disabled clearable :value="getLookValue()" />
              <div class="for-label" style="margin-bottom: 15px;">新密码：</div>
              <Input class="bg-color-242631 height-44 login-input" style="margin-bottom: 20px;" type="password"  v-model.trim="form.password" clearable placeholder="请输入新密码" />
              <div class="for-label" style="margin-bottom: 15px;">确认新密码：</div>
              <Input class="bg-color-242631 height-44 login-input" style="margin-bottom: 20px;" type="password"  v-model.trim="form.confirmPassword" clearable placeholder="请输入确认新密码" />
            </div>
            <Button class="next-btn" type="info" :loading="loading3" @click="handleSubmit(3)" ghost>下一步</Button>
          </div>
        </div>
      </template>
      <template v-if="step === 4">
          <div class="b-section main">
          <div>
            <div style="text-align: center;">
              <img src="@/assets/image/order-success-icon.png" />
            </div>
            <div class="s-tips">恭喜您，密码重置成功！</div>
            <Button class="next-btn" type="info" ghost to="/login">立即登录</Button>
          </div>
        </div>
      </template>
    </div>
    <footBar />
  </div>
</template>

<script>
import footBar from "components/footBar.vue";
import navStepList3 from "components/navStepList3";
import navigationBar from "components/navigationBar";
import breadcrumb from "components/breadcrumb";
import { makeCode } from "utils/identify";
import identify from "components/identify.vue";
import smsBtn from "components/smsBtn.vue";
import { getEncrypt } from "utils/encrypt";
import {
  verifyCode,
  forgetPwdVerify,
  forgetPwdVerifySmsCode,
  forgetPwdChange,
} from "api/user.js";
export default {
  name: "sige",
  components: {
    breadcrumb,
    navigationBar,
    navStepList3,
    identify,
    smsBtn,
    footBar
  },
  data() {
    return {
      step: 1,
      identifyCode: "",
      form: {
        name: "",
        password: "",
        code: "",
        confirmPassword: "",
      },
      account: "",
      loading1: false,
      loading2: false,
      loading3: false,
      phone: '',
      email: ''
    };
  },
  created() {
    this.identifyCode = makeCode();
  },
  methods: {
    getLookValue() {
      let arr = []
      if (this.phone && this.phone.length > 0) {
        arr.push(this.phone)
      }
      if (this.email && this.email.length > 0) {
        arr.push(this.email)
      }
      return arr.join("/")
    },
    reloadCodeEvent() {
      this.identifyCode = makeCode();
    },
    toLogin() {
      this.$router.replace({ name: "login" });
    },
    getCodeEvent(callback) {
      verifyCode(this.verifyCode)
        .then((res) => {
          if (res.code === 200 && res.result) {
            callback(true);
          }
        })
        .catch(() => {
          this.$refs.smsBtn.reset();
        });
    },
    handleSubmit(step) {
      if (step === 1) {
        if (!this.form.name) {
          this.$Message.warning("请输入手机号/邮箱！");
          return false;
        }
        if (!this.form.code) {
          this.$Message.warning("请输入验证码！");
          return false;
        }
        if (this.form.code.toLowerCase() !== this.identifyCode.toLowerCase()) {
          this.$Message.warning("请输入正确验证码！");
          return false;
        }

        this.loading1 = true;
        forgetPwdVerify({ account: this.form.name })
          .then((res) => {
            this.loading1 = false;
            this.form.code = "";
            if (res.code === 200 && res.result) {
              this.step = step + 1;
              this.verifyCode = res.data.msgCode;
              this.phone = res.data.phone;
              this.email = res.data.email;
              this.reloadCodeEvent();
              this.$nextTick(() => {
                this.$refs.smsBtn.getCodeEvent();
              });
            }
          })
          .catch(() => {
            this.loading1 = false;
            this.form.code = "";
            this.reloadCodeEvent();
          });
      } else if (step === 2) {
        if (!this.verifyCode) {
          this.$Message.warning("秘钥错误,请重新验证账户名称!");
          return false;
        }
        this.loading2 = true;
        forgetPwdVerifySmsCode({
          code: this.form.code,
          verifyCode: this.verifyCode,
        })
          .then((res) => {
            this.loading2 = false;
            const { code, data, result } = res;
            if (code === 200 && result) {
              this.step = step + 1;
              this.verifyCode = data;
              this.form.code = "";
            }
          })
          .catch(() => {
            this.loading2 = false;
            this.form.code = "";
          });
      } else if (step === 3) {
        this.loading3 = true;
        const params = {
          cpwd: getEncrypt(this.form.confirmPassword),
          npwd: getEncrypt(this.form.password),
          msg: this.verifyCode,
        };
        forgetPwdChange(params)
          .then((res) => {
            this.loading3 = false;
            const { code, result } = res;
            if (code === 200 && result) {
              this.step = step + 1;
            }
          })
          .catch(() => {
            this.loading3 = false;
          });
      }
    },
  },
};
</script>
<style lang="less" scoped>
  .main{
    .flex(center, center);
    min-height: 444px;
  }
  .next-btn{
    display: block;
    height: 56px;
    line-height: 56px;
    width: 240px;
    margin: 50px auto 0;
    // 主流程按钮：实心蓝底白字
    &.ivu-btn{
      background-color: @brand;
      border-color: @brand;
      color: #fff;
    }
    &.ivu-btn:hover{
      background-color: @brand-hover;
      border-color: @brand-hover;
      color: #fff;
    }
    &.ivu-btn:active{
      background-color: @brand-deep;
      border-color: @brand-deep;
      color: #fff;
    }
  }
  /deep/.sms-btn{
    margin-left: 20px;
    .ivu-btn{
      width: 120px;
      background-color: #288DF0;
      color: #fff;
      border-color:#c4332e;
    }
    
  }
  .t-tips{
    font-size: 27px;
    line-height: 60px;
    margin-bottom: 30px;
    color: #C4332E;
    text-align: center;
  }
  .s-tips{
    font-size: 27px;
    line-height: 60px;
    margin: 15px 0 0;
    color: #fff;
    text-align: center;
  }
</style>
